/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { SandboxActions } from "components/actions/SandboxActions";
import { MainHeader } from "components/main-header/MainHeader";
import { useUrlParameters } from "hooks/useUrlParameters";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { runtimeEnv } from "configuration";
import { useAppSelector } from "store";
import styles from "./RootLayout.module.css";

export const RootLayout = () => {
  const layout = useAppSelector((state) => state.settings.layout);
  const location = useLocation();

  useUrlParameters();

  useEffect(() => {
    if (window.self !== window.top) {
      const payload = {
        pathname: location.pathname,
        search: location.search.startsWith("?") ? location.search.slice(1) : location.search,
      };
      window.parent.postMessage(JSON.stringify(payload), runtimeEnv.REACT_APP_TARGET_ORIGIN);
    }
  }, [location]);

  return (
    <div id="root-modal-dialog" className={[styles.rootLayout, "sbx-app"].join(" ")}>
      <SandboxActions>
        {layout.mainHeader !== false ? <MainHeader /> : <div></div>}
        <Outlet />
      </SandboxActions>
    </div >
  )
};
